import React, { useState, useEffect } from 'react';
import {
    Bouton,
    Col,
    GroupeBouton,
    Modale,
    ModaleContent,
    ModaleFooter,
    ModaleTitre,
    Row,
} from '@design-system-etat/dsfr-react';
import PropTypes from 'prop-types';
import InputFiles from 'components/Commun/Form/InputFiles';
import { useDispatch, useSelector } from 'react-redux';
import { getAPI, postAPI, reinitialiseAPI } from 'store/apiReducer';
import usagerClientReducer from 'store/usagerReducer';
import { FormProvider, useForm } from 'react-hook-form';
import {
    MOTIF_DEMANDE_PIECES_JOINTES,
    TITRES_PIECES_JOINTES,
    TRANSITION_COMPLETER_PJ,
} from 'constants/titreDetention.constants';
import { getArrayFilesToSend } from 'utils/fileFunction';
import FileUploadeFront from 'components/Commun/Form/InputFiles/Model/FileUploadeFront';
import {
    API_TRANSITION_TITRE_DETENTION,
    CONTEXT_MODIFIER_TITRE_DETENTION,
    API_GET_MES_DEMARCHES_EN_COURS,
    CONTEXT_MES_DEMARCHES_EN_COURS,
} from 'constants/apiUrls.constants';

const ModalePiecesJointesTitreDetention = ({ titreDetention, fermerModale }) => {
    const dispatch = useDispatch();
    const [activerBoutonValider, setActiverBoutonValider] = useState(false);
    const { uuid, typeTitreDetention, piecesJointesManquantes } = titreDetention;
    const hookForm = useForm({
        mode: 'onChange',
    });
    const { handleSubmit, formState, getValues } = hookForm;

    const getData = async () => {
        const data = await Promise.all(
            Object.entries(getValues('pieceJointes')).map(async ([type, pieceJointe]) => {
                const fichiers = await getArrayFilesToSend(
                    pieceJointe.fichiers
                        ? pieceJointe.fichiers.filter(
                              (fichier) => fichier instanceof FileUploadeFront,
                          )
                        : [],
                );
                return {
                    type,
                    fichiers,
                };
            }),
        );

        return data.filter(({ fichiers }) => fichiers.length > 0);
    };

    useEffect(() => {
        setActiverBoutonValider(false);
        const fetchData = async () => {
            const data = await getData();
            return data;
        };

        fetchData().then((data) => {
            if (data.length === piecesJointesManquantes.length) {
                setActiverBoutonValider(true);
            }
        });
    }, [
        getValues('pieceJointes.acteNaissance.fichiers'),
        getValues('pieceJointes.certificatMedicalPsychiatrique.fichiers'),
        getValues('pieceJointes.piecesIdentite.fichiers'),
        getValues('pieceJointes.justificatifDomicile.fichiers'),
        getValues('pieceJointes.licenceTir.fichiers'),
        getValues('pieceJointes.licenceBallTrap.fichiers'),
        getValues('pieceJointes.licenceSki.fichiers'),
        getValues('pieceJointes.avisPrealableFftir.fichiers'),
    ]);

    const onSubmit = async () => {
        const data = await getData();
        dispatch(
            postAPI(
                usagerClientReducer,
                API_TRANSITION_TITRE_DETENTION.replace(':type', typeTitreDetention)
                    .replace(':uuid', uuid)
                    .replace(':transition', TRANSITION_COMPLETER_PJ),
                { pieceJointes: { ...data } },
                CONTEXT_MODIFIER_TITRE_DETENTION,
            ),
        );
    };
    const { data: titre, isLoading: isLoadingTitreDetentionModifier } = useSelector(
        (state) => state.titreDetention.modifier,
    );

    if (titre) {
        dispatch(reinitialiseAPI(CONTEXT_MODIFIER_TITRE_DETENTION));
        fermerModale();
        // Recharger mes demarches ...
        dispatch(
            getAPI(
                usagerClientReducer,
                API_GET_MES_DEMARCHES_EN_COURS,
                CONTEXT_MES_DEMARCHES_EN_COURS,
            ),
        );
    }

    return (
        <Modale taille="lg" closeCallback={fermerModale}>
            <ModaleTitre>Modification de pièces</ModaleTitre>
            <ModaleContent>
                <p>
                    Une ou plusieurs des pièces constituant votre demande d'autorisation
                    d'acquisition et de détention sont illisibles ou invalides. Veuillez cliquer sur
                    "Importer" afin de sélectionner pour chaque élément demandé une pièce lisible et
                    valide. Une fois toutes les pièces importées, veuillez cliquer sur le bouton
                    "Valider"
                </p>
                <FormProvider {...hookForm}>
                    <form onSubmit={handleSubmit(onSubmit)}>
                        {piecesJointesManquantes.map(({ type, motif }) => (
                            <Row key={type} className="margin-top-md">
                                <Col col={12}>
                                    <InputFiles
                                        label={`${TITRES_PIECES_JOINTES[type]} (${MOTIF_DEMANDE_PIECES_JOINTES[motif]})`}
                                        name={`pieceJointes.${type}.fichiers`}
                                        error={formState.errors ? formState.errors[type] : null}
                                    />
                                </Col>
                            </Row>
                        ))}
                    </form>
                </FormProvider>
            </ModaleContent>
            <ModaleFooter>
                <GroupeBouton alignementHorizontal="right" isHorizontal>
                    <Bouton name="retour" label="Retour" onClick={fermerModale} />
                    <Bouton
                        label="Valider"
                        niveau="primaire"
                        onClick={onSubmit}
                        disabled={!activerBoutonValider}
                        isLoading={isLoadingTitreDetentionModifier}
                    />
                </GroupeBouton>
            </ModaleFooter>
        </Modale>
    );
};

ModalePiecesJointesTitreDetention.propTypes = {
    fermerModale: PropTypes.func.isRequired,
    titreDetention: PropTypes.object,
};

export default ModalePiecesJointesTitreDetention;
